module.exports = __webpack_public_path__ + "static/media/19691409_10208702678913999_732392149_n.b69ae84b.jpg";